import React from "react"
import TypeformEmbed from "../common/TypeformEmbed"

const CancellationRequestPage = () => {
  return <TypeformEmbed id="DDldWlWW" />
}

export default CancellationRequestPage
